module.exports = __webpack_public_path__ + "img/hoslogo15.0107ac42.png";